<template>
    <el-dialog
        :title="title"
        width="800px"
        :visible.sync="visible"
        :modal="false"
    >
        <el-form-item v-if="title === '请选择可发起本审批的部门'" :labelCol=" { span: 3 } " label="部门权限">
            <el-radio-group v-model="scope">
                <el-radio label="本级">本级</el-radio>
                <el-radio label="本级及以下">本级及以下</el-radio>
            </el-radio-group>
        </el-form-item>
        <div class="picker">
            <div class="candidate" v-loading="loading">
                <div>
                    <el-input
                        v-model="search"
                        @input="searchUser"
                        @clear="clearOptions"
                        style="width: 90%;"
                        size="small"
                        clearable
                        :placeholder="type === 'org' ? '输入搜索' : type === 'dept' ? '搜索部门' : type === 'post' ? '搜索岗位' : '搜索人员'"
                        prefix-icon="el-icon-search"
                    />
                    <span style="float: right;margin-top:5px; color:#38adff" @click="clearOptions">重置</span>
                    <div v-show="!showUsers">
                        <ellipsis hover-tip style="color: #8c8c8c; padding: 5px 0 0" :row="1" :length="15" tooltip :content="deptStackStr">
                            <i class="el-icon-office-building" />
                        </ellipsis>
                        <div style="margin-top: 5px">
                            <el-checkbox v-model="checkAll" @change="handleCheckAllChange" :disabled="!multiple">全选</el-checkbox>
                            <span v-show="deptStack.length > 0" class="top-dept" @click="beforeNode">上一级</span>
                        </div>
                    </div>
                </div>
                <div class="org-items" :style="type === 'role' ? 'height: 350px' : ''">
                    <el-empty :image-size="100" description="似乎没有数据" v-show="orgs.length === 0" />
                    <div v-for="(org, index) in orgs" :key="index" :class="orgItemClass(org)">
                        <span @click.stop>
                            <el-checkbox v-model="org.selected" :max="2" :disabled="disableDept(org)" @change="selectChange(org)" />
                        </span>
                        <div v-if="org.type === 'dept'" style="width: 80%;">
                            <i class="el-icon-folder-opened" />
                            <span class="name">{{ org.name }}</span>
                            <span class="" v-if="type ==='dept'">
                                <span @click.stop="nextNode(org)" v-if="!org.leaf" :class="`next-dept${org.selected ? '' : ''}`" class="top-dept">
                                    <i class="iconfont icon-map-site" />下级
                                </span>
                                <span v-else :class="`next-dept${org.selected ? '-disable' : ''}`" class="top-dept" />
                            </span>
                            <span v-else @click.stop="nextNode(org)" :class="`next-dept${org.selected ? '' : ''}`" class="top-dept">
                                <i class="iconfont icon-map-site" />下级
                            </span>
                        </div>
                        <div
                            v-else-if="org.type === 'user' || org.type === 'post'"
                            style="width: 80%;display: flex; align-items: center"
                        >
                            <span class="name">{{ org.name }}</span>
                        </div>
                        <div style="display: inline-block" v-else>
                            <i class="iconfont icon-bumen" />
                            <span class="name">{{ org.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="selected">
                <div class="count">
                    <span>已选 {{ select.length }} 项</span>
                    <span @click="clearSelected">清空</span>
                </div>
                <div class="org-items" style="height: 350px;">
                    <el-empty :image-size="100" description="请点击左侧列表选择数据" v-show="select.length === 0" />
                    <div v-for="(org, index) in changeDeptName(select)" :key="index" :class="orgItemClass(org)">
                        <div v-if="org.type === 'dept'">
                            <i class="el-icon-folder-opened" />
                            <span style="position: static" class="name">{{ org.name }}</span>
                        </div>
                        <div v-else-if="org.type === 'user' || org.type === 'post'" style="display: flex; align-items: center">
                            <span class="name">{{ org.name }}</span>
                        </div>
                        <div v-else>
                            <i class="iconfont icon-bumen" />
                            <span class="name">{{ org.name }}</span>
                        </div>
                        <i class="el-icon-close" @click="noSelected(index)" />
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="selectOk">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { debounce } from '@/utils'
import Ellipsis from './Ellipsis.vue'
let getOrgTree, getUserByName, getDeptUser, getRole, getPost, getPostListPage;
export default {
    name: 'OrgPicker',
    components: {
        Ellipsis
    },
    props: {
        title: {
            default: '请选择',
            type: String,
        },
        type: {
            default: 'dept', // org选择部门/人员  user-选人  dept-选部门 role-选角色 post-岗位
            type: String,
        },
        multiple: { // 是否多选
            default: false,
            type: Boolean,
        },
        selected: {
            default: () => [],
            type: Array,
        },
        max: {
            type: [String, Number],
            default: 1000,
        },
        limits: {
            type: [Array, Boolean],
            default: false,
        },
        content: {
            type: String,
            default: ''
        }
    },
    watch: {
        visible: {
            handler (val) {
                if (this.visible === true) {
                    this.init()
                    this.type === 'role' ? this.getRoleList() : this.getOrgList()
                }
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        const { option: { api } } = this.$attrs
        // const {
        //     getOrgTree,
        //     getUserByName,
        //     getDeptUser,
        //     getRole,
        //     getPost,
        //     getPostListPage
        // } = api
        getOrgTree = api.getOrgTree
        getUserByName = api.getUserByName
        getDeptUser = api.getDeptUser
        getRole = api.getRole
        getPost = api.getPost
        getPostListPage = api.getPostListPage
    },
    data () {
        return {
            visible: false,
            loading: false,
            checkAll: false,
            nowDeptId: null,
            isIndeterminate: false,
            searchUsers: [],
            searchDepts: [],
            searchPosts: [],
            deptUser: [],
            deptPost: [],
            nodes: [],
            select: [],
            search: '',
            deptStack: [],
            scope: '本级',
            throttledSearch: debounce(this.searchUser, 1000, false), // 使用节流函数包装原始函数
        }
    },
    computed: {
        deptStackStr () {
            return String(this.deptStack.map(v => v.name)).replaceAll(',', ' > ')
        },
        orgs () {
            return !this.search || this.search.trim() === '' ? this.nodes : this.type === 'dept' ? this.searchDepts : this.type === 'post' ? this.searchPosts : this.searchUsers
        },
        showUsers () {
            return this.search || this.search.trim() !== ''
        },
        headerTitle () {
            switch (this.type) {
                case 'user':
                return '人员'
                case 'role':
                return '系统角色'
                case 'post':
                return '岗位'
                case 'dept':
                return '部门'
                default:
                return null
            }
        },
        currentNodeDeptCode () {
            return this.$store.state.currentNodeDeptCode
        },
        searchDeptCode () {
            const path = ['/pc/event/workspace/order/detail', '/eventCenter/flow/center/deptDetail']
            const { option: { config } } = this.$attrs
            return path.indexOf(window.location.href) !== -1 ? this.currentNodeDeptCode || config.VUE_APP_DEPTCODE : config.VUE_APP_DEPTCODE
        }
    },
    methods: {
        clearOptions () {
            this.search = ''
            this.deptStack = []
            this.getOrgList()
        },
        show () {
            this.visible = true
        },
        orgItemClass (org) {
            return {
                'org-item': true,
                'org-dept-item': org.type === 'dept',
                'org-user-item': org.type === 'user' || org.type === 'post',
                'org-role-item': org.type === 'role',
            }
        },
        disableDept (node) {
            return (this.type === 'user' || this.type === 'post') && node.type === 'dept'
        },
        // 获取岗位
        _getPostList (deptCode, dept, node) {
            getPostListPage({ deptCode: deptCode, status: 1 }).then(res => {
                this.deptPost = res.data && res.data.list.map((item) => {
                    return {
                        ...item,
                        pid: item.pid,
                        type: 'post',
                        name: item.postName,
                        deptCode: node.deptCode,
                        deptName: node.deptName,
                    }
                })
                // console.log('节点', dept)
                this.nodes = dept.concat(this.deptPost)
                // console.log('组合部门+部门岗位', this.nodes)
                this.selectToLeft()
            })
        },
        getRoleList () {
            getRole().then(rsp => {
                this.nodes = rsp.data && rsp.data.list.map((item) => {
                    return {
                        ...item,
                        type: 'role',
                        name: item.roleName,
                    }
                })
                this.selectToLeft()
            })
        },
        getOrgList (parentCode, node) {
            this.loading = true
            getOrgTree({ parentCode: parentCode || this.searchDeptCode, type: this.type }).then(rsp => {
                this.loading = false
                this.nodes = rsp.data.map((item) => {
                    return {
                        ...item,
                        type: 'dept',
                        name: !item.thirdDeptCode ? item.parentName + '-' + item.deptName : item.deptCode === item.thirdDeptCode ? item.parentName + '-' + item.deptName : item.thirdDeptName + '-' + item.deptName,
                    }
                })
                this.type === 'org' || this.type === 'user'
                ? this.getDeptUserList(parentCode || this.searchDeptCode, this.nodes)
                : this.type === 'post'
                    ? this._getPostList(parentCode || this.searchDeptCode, this.nodes, node)
                    : this.selectToLeft()
            }).catch(err => {
                this.loading = false
                this.$message.error(err.response.data)
            })
        },
        getShortName (name) {
            if (name) {
                return name.length > 2 ? name.substring(1, 3) : name
            }
            return '**'
        },
        getDeptUserList (parentCode, dept) {
            getDeptUser(parentCode).then(res => {
                this.deptUser = res.data.map((item) => {
                    return {
                        ...item,
                        type: 'user',
                        name: item.deptName + item.username,
                        id: item.userId,
                        newId: item.deptCode + item.userId,
                    }
                })
                this.nodes = dept.concat(this.deptUser)
                this.selectToLeft()
            })
        },
        searchUser () {
            if (this.type === 'dept') {
                this.searchDept()
            } else if (this.type === 'post') {
                this.searchPost()
            } else {
                const userName = this.search.trim()
                this.searchUsers = []
                this.loading = true
                getUserByName({ username: userName }).then(rsp => {
                    const flattenedData = this.flattenData(rsp.data)
                    this.loading = false
                    this.searchUsers = flattenedData.map((item) => {
                        return {
                            ...item,
                            type: 'user',
                            name: item.department + '-' + item.username,
                            id: item.userId,
                            newId: item.deptCode + item.userId,
                        }
                    })
                    this.selectToLeft()
                }).catch(err => {
                    console.log(err)
                    this.loading = false
                    this.$message.error('接口异常')
                })
            }
        },
        searchDept () {
            const deptName = this.search.trim()
            if (!deptName || deptName === '') return
            this.loading = true
            this.searchDepts = []
            this.nodes = []
            getOrgTree({ deptName: deptName }).then(rsp => {
                this.loading = false
                this.searchDepts = rsp.data.map((item) => {
                return {
                    ...item,
                    type: 'dept',
                    name: item.deptCode === item.thirdDeptCode ? item.parentName + '-' + item.deptName : item.thirdDeptName + '-' + item.deptName,
                }
                })
                this.selectToLeft()
            }).catch(err => {
                console.log(err)
                this.loading = false
                this.$message.error('接口异常')
            })
        },
        searchPost () {
            const postName = this.search.trim()
            if (!postName || postName === '') return
            this.loading = true
            this.searchPosts = []
            this.nodes = []
            getPost({ postName: postName }).then(rsp => {
                this.loading = false
                this.searchPosts = rsp.data.map((item) => {
                return {
                    ...item,
                    type: 'post',
                    name: item.deptName + '-' + item.postName,
                }
                })
                this.selectToLeft()
            }).catch(err => {
                console.log(err)
                this.loading = false
                this.$message.error('接口异常')
            })
        },
        selectToLeft () {
            const nodes = this.search.trim() === '' ? this.nodes : this.type === 'dept' ? this.searchDepts : this.type === 'post' ? this.searchPosts : this.searchUsers
            if (this.type === 'user') {
                nodes.forEach(node => {
                    for (let i = 0; i < this.select.length; i++) {
                        if (this.select[i].newId === node.newId && this.select[i].name === node.name) {
                            node.selected = true
                        break
                        } else {
                            node.selected = false
                        }
                    }
                })
            } else {
                nodes.forEach(node => {
                    for (let i = 0; i < this.select.length; i++) {
                        if (this.select[i].id === node.id && this.select[i].name === node.name) {
                            node.selected = true
                        break
                        } else {
                            node.selected = false
                        }
                    }
                })
            }
        },
        selectChange (node) {
            if (this.select.length + 1 > this.max) {
                this.$message.warning('最多选择' + this.max + '项，请重新选择')
                return
            }
            node.selected = !node.selected
            if (node.selected) {
                this.checkAll = false
                if (this.type === 'user') {
                    for (let i = 0; i < this.select.length; i++) {
                        if (this.select[i].newId === node.newId) {
                            this.select.splice(i, 1)
                            break
                        }
                    }
                } else {
                    for (let i = 0; i < this.select.length; i++) {
                        if (this.select[i].id === node.id) {
                            this.select.splice(i, 1)
                        break
                        }
                    }
                }
                node.selected = false
            } else if (!this.disableDept(node)) {
                node.selected = true
                const nodes = this.search.trim() === '' ? this.nodes : this.type === 'dept' ? this.searchDepts : this.type === 'post' ? this.searchPosts : this.searchUsers
                if (!this.multiple) {
                    if (this.type === 'user') {
                        nodes.forEach(nd => {
                            if (node.newId !== nd.newId) {
                                nd.selected = false
                            }
                        })
                    } else {
                        nodes.forEach(nd => {
                            if (node.id !== nd.id) {
                                nd.selected = false
                            }
                        })
                    }
                }
                if (node.type === 'dept') {
                    if (!this.multiple) {
                        this.select = [node]
                    } else {
                        this.select.unshift(node)
                    }
                } else {
                    if (!this.multiple) {
                        this.select = [node]
                    } else {
                        this.select.push(node)
                    }
                }
            }
        },
        noSelected (index) {
            let nodes = this.nodes
            for (let f = 0; f < 2; f++) {
                for (let i = 0; i < nodes.length; i++) {
                    if (nodes[i].id === this.select[index].id) {
                        nodes[i].selected = false
                        this.checkAll = false
                        break
                    }
                }
                nodes = this.type === 'dept' ? this.searchDepts : this.type === 'post' ? this.searchPosts : this.searchUsers
            }
            this.select.splice(index, 1)
        },
        handleCheckAllChange () {
            this.nodes.forEach(node => {
                if (this.checkAll) {
                    if (!node.selected && !this.disableDept(node)) {
                        node.selected = true
                        this.select.push(node)
                    }
                } else {
                    node.selected = false
                    for (let i = 0; i < this.select.length; i++) {
                        if (this.select[i].id === node.id) {
                            this.select.splice(i, 1)
                            break
                        }
                    }
                }
            })
        },
        nextNode (node) {
            this.search = ''
            this.nowDeptId = node.id
            this.deptStack.push(node)
            this.getOrgList(node.deptCode, node)
        },
        beforeNode () {
            this.getOrgList(this.deptStack[this.deptStack.length - 1].parentCode)
            if (this.deptStack.length === 0) {
                return
            }
            if (this.deptStack.length < 2) {
                this.nowDeptId = null
            } else {
                this.nowDeptId = this.deptStack[this.deptStack.length - 2].id
            }
            this.deptStack.splice(this.deptStack.length - 1, 1)
        },
        recover () {
            this.checkAll = false
            this.select = []
            this.nodes.forEach((nd) => { nd.selected = false })
        },
        selectOk () {
            this.$emit('ok', Object.assign([], this.select.map(v => {
                if(this.title === '请选择可发起本审批的部门' && v.type === 'dept') v.scope = this.scope
                v.avatar = undefined
                return v
            })))
            this.visible = false
            this.recover()
        },
        clearSelected () {
            this.$confirm('您确定要清空已选中的项?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.recover()
            })
        },
        close () {
            this.$emit('close')
            this.recover()
        },
        init () {
            this.checkAll = false
            this.nowDeptId = null
            this.deptStack = []
            this.nodes = []
            this.select = Object.assign([], this.selected)
            this.selectToLeft()
        },
        // 数组二维转一维
        flattenData (arr) {
            // 使用 map 方法遍历数组并添加属性
            const newArray = arr.map(parent => {
                // 复制父元素，以避免修改原始数组
                const newParent = { ...parent }
                // 处理子元素
                newParent.positions = parent.positions.map(child => {
                    // 复制子元素，以避免修改原始数组
                    const newChild = { ...child }
                    // 添加新属性到子元素
                    newChild.username = newParent.username
                    newChild.userId = newParent.userId
                    newChild.mobile = newParent.mobile
                    return newChild
                })
                return newParent
            })
            const newArr2 = newArray.flatMap(v => v.positions)
            return newArr2
        },
        // 部门拼接
        changeDeptName (arr) {
            if (arr.length > 0 && this.type === 'dept') {
                const newArray = arr.map((item) => {
                console.log('item---', item)
                return {
                    ...item,
                    name: item.parentName + '-' + item.deptName,
                }
                })
                console.log('newArray', newArray)
                return newArray
            } else {
                return arr
            }
        }
    }
}
</script>
<style lang="less" scoped>
@containWidth: 380px;

.candidate,
.selected {
    position: absolute;
    display: inline-block;
    width: @containWidth;
    height: 400px;
    border: 1px solid #e8e8e8;
}

.picker {
    height: 402px;
    position: relative;
    text-align: left;

  .candidate {
    left: 0;
    top: 0;

    .role-header {
      padding: 10px !important;
      margin-bottom: 5px;
      border-bottom: 1px solid #e8e8e8;
    }

    .top-dept {
      margin-left: 20px;
      cursor: pointer;
      color: #38adff;
    }

    .next-dept {
      float: right;
      // color: @theme-primary;
      cursor: pointer;
    }

    .next-dept-disable {
      float: right;
      color: #8c8c8c;
      cursor: not-allowed;
    }

    &>div:first-child {
      padding: 5px 10px;
    }

  }

  .selected {
    right: 0;
    top: 0;
  }

  .org-items {
    overflow-y: auto;
    height: 310px;

    .el-icon-close {
      position: absolute;
      right: 5px;
      cursor: pointer;
      font-size: larger;
    }

    .org-dept-item {
      // padding: 10px 5px;

      &>div {
        display: inline-block;

        &>span:last-child {
          position: absolute;
          right: 5px;
        }
      }
    }

    .org-role-item {
      display: flex;
      align-items: center;
      padding: 10px 5px;
    }

    /deep/ .org-user-item {
      display: flex;
      align-items: center;
      padding: 5px;

      &>div {
        display: inline-block;
      }

      .avatar {
        width: 35px;
        text-align: center;
        line-height: 35px;
        // background: @theme-primary;
        color: white;
        border-radius: 50%;
      }
    }

    /deep/ .org-item {
      margin: 0 5px;
      border-radius: 5px;
      position: relative;

      .el-checkbox {
        margin-right: 10px;
      }

      .name {
        margin-left: 5px;
      }

      &:hover {
        background: #f1f1f1;
      }
    }
  }
}

.selected {
  border-left: none;

  .count {
    width: calc(@containWidth - 20px);
    padding: 10px;
    display: inline-block;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;

    &>span:nth-child(2) {
      float: right;
      color: #c75450;
      cursor: pointer;
    }
  }
}

/deep/ .el-dialog__body {
  padding: 10px 20px;
}

.disabled {
  cursor: not-allowed !important;
  color: #8c8c8c !important;
}

::-webkit-scrollbar {
  float: right;
  width: 4px;
  height: 4px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #efefef;
}

.w-8{
  width: 80%;
}
</style>